import { render } from "./account.vue?vue&type=template&id=2da5aaae"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"

import "./account.vue?vue&type=style&index=0&id=2da5aaae&lang=postcss"
script.render = render

export default script